import type User from "flarum/common/models/User";

import app from 'flarum/forum/app';
import {extend} from 'flarum/common/extend';

import Button from 'flarum/common/components/Button';
import UserControls from 'flarum/forum/utils/UserControls';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import Separator from 'flarum/common/components/Separator';

import UpdateUserEconomyModal from './components/UpdateUserEconomyModal';

app.initializers.add('rhodes-island/economy', () => {
  extend(UserControls, 'moderationControls', function(items, user) {
    if (user.attribute('canUpdateEconomy')) {
      items.add('update-economy', <Button icon="fas fa-money-bill" onclick={editUserEconomy.bind(this, user)}>
        {app.translator.trans('rhodes-island.lib.economy.update_user_economy')}
      </Button>)
    }
  });
  extend(SessionDropdown.prototype, 'items', function(items) {
    const user = app.session.user!;
    const money = user.attribute('money');
    items.add('user-money', <Button icon="fas fa-money-bill" className="UserMoney">
      {app.translator.trans('rhodes-island.lib.economy.unit', { amount: money })}
    </Button>, 200);
    items.add('user-money-separator', <Separator/>, 150);
  })
});

function editUserEconomy(user: User) {
  app.modal.show(UpdateUserEconomyModal, { user })
}
